import { SxProps } from '@mui/material';
import { lightTheme } from '../../theme/index';

const { palette, spacing } = lightTheme;

export const rentTypeMarginStyles = {
  marginRight: { xs: '0', md: '5rem' }
};

export const radioGroupLabel = {
  marginBottom: '0'
};

const styles: Record<string, SxProps> = {
  mainContainer: {
    padding: spacing(1),
    width: { md: '33vw', xs: '100vw' }
  },
  headerDivider: {
    width: '100vw',
    marginLeft: `-${spacing(1)}`,
    borderColor: palette.primary[200],
    display: { xs: 'block', md: 'none' }
  },
  headerBox: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  filterHeading: {
    textAlign: { xs: 'center', md: 'left' },
    width: '100%'
  },
  closeIcon: {
    cursor: 'pointer',
    width: { sm: '0.75rem', md: '1rem' }
  },

  filterOptions: {
    display: 'flex',
    flexDirection: 'column',
    gap: spacing(1)
  },

  inputLabel: {
    color: palette.grey.main,
    '& > .MuiTypography-root': {
      fontWeight: 600
    }
  },

  selectInput: {
    backgroundColor: palette.grey['50'],
    borderRadius: '0.25rem',

    fieldset: {
      border: `0.063rem solid ${palette.primary['200']}`
    },
    '&:hover .Mui-error fieldset': {
      borderColor: palette.brightRed.main
    },
    '& .MuiOutlinedInput-root': {
      '&:hover fieldset': {
        border: `0.063rem solid ${palette.primary['200']}`
      },
      '&.Mui-focused fieldset': {
        borderColor: palette.primary['200']
      },
      '&.Mui-error fieldset': {
        border: `0.063rem solid ${palette.brightRed.main}`
      }
    },
    '.MuiFormHelperText-root': {
      margin: '0',
      paddingTop: '0.5rem',
      fontSize: '0.875rem',
      lineHeight: '1.125rem'
    },
    svg: {
      fill: `${palette.gradient.main}`
    },
    '.MuiOutlinedInput-input': {
      backgroundColor: palette.grey['50'],
      '::-ms-reveal': {
        display: 'none'
      }
    }
  },

  checkboxGroup: {
    paddingLeft: spacing(0.5),
    display: 'flex',
    flexDirection: 'column',
    gap: spacing(0.5)
  },

  radioGroup: {
    paddingLeft: spacing(0.5),
    display: 'flex',
    gap: spacing(0.5)
  },
  groupItem: {
    '&:not(:first-child)': {},
    '.MuiRadio-root, .MuiCheckbox-root': {
      padding: 0,
      paddingRight: spacing(0.5),
      svg: {
        color: palette.primary.main
      }
    },

    '.Mui-checked + .MuiTypography-root': {
      color: { xs: palette.primary.main, md: palette.grey.main }
    }
  },

  divider: {
    borderColor: palette.primary[200],
    display: { xs: 'none', md: 'block' }
  },

  applyButton: {
    marginTop: spacing(2)
  },

  applyBtnContainer: {
    position: {
      xs: 'fixed',
      md: 'sticky'
    },
    bottom: spacing(0.5),
    left: spacing(0.5),
    right: spacing(0.5),
    alignItems: 'center'
  },

  priceRange: {
    display: 'flex',
    gap: {
      xs: spacing(0.5),
      md: spacing(1)
    }
  }
};

export default styles;
